export const API_URL = "https://my-website-backend-mwdy.onrender.com";
export const LOCAL_API_URL = "http://localhost:8000";